/* ============================================================
   Fenice Bella — Mobile Bottom Navigation v2
   File: assets/mobile-bottom-nav.js
   ============================================================ */

(function () {
  'use strict';

  /* ─── Selectors ─── */
  var NAV_ID     = 'fb-nav';
  var CIRCLE_ID  = 'fb-nav-circle';
  var BADGE_ID   = 'fb-cart-badge';

  /*
   * Menu drawer button — the actual <button> inside <menu-drawer>
   * Try multiple strategies so it survives theme updates
   */
  var MENU_SELECTORS = [
    /* Exact element provided */
    'menu-drawer button.burger-js',
    /* Attribute-based (most stable) */
    'button[data-modal-toggle-menu-dawer]',
    'button[data-modal-toggle-menu-drawer]',
    /* Class-based fallbacks */
    '.burger-js',
    '.burger-menu button',
    '.burger-menu-button',
    /* Generic Shopify drawer openers */
    '[data-drawer-open]',
    '.header__icon--menu',
    'button[aria-controls*="menu"]',
    'button[aria-controls*="drawer"]'
  ];

  /* ─── DOM ─── */
  var nav    = document.getElementById(NAV_ID);
  var circle = document.getElementById(CIRCLE_ID);
  var badge  = document.getElementById(BADGE_ID);

  if (!nav || !circle) return;

  var items   = Array.prototype.slice.call(nav.querySelectorAll('.fb-nav__item'));
  var menuBtn = nav.querySelector('[data-page="menu"]');

  /* ─── Find Shopify menu opener ─── */
  function findShopifyMenuBtn() {
    for (var i = 0; i < MENU_SELECTORS.length; i++) {
      var el = document.querySelector(MENU_SELECTORS[i]);
      if (el && !nav.contains(el)) return el;
    }
    return null;
  }

  /* ─── Active page detection from URL ─── */
  function detectPage() {
    var path = window.location.pathname;
    if (path === '/')                           return 'home';
    if (path.startsWith('/cart'))               return 'cart';
    if (path.startsWith('/collections'))        return 'collections';
    if (path.startsWith('/products'))           return 'collections';
    return 'home';
  }

  /* ─── Position circle under element ─── */
  function positionCircle(el, instant) {
    var navRect  = nav.getBoundingClientRect();
    var itemRect = el.getBoundingClientRect();
    var cx = itemRect.left - navRect.left + itemRect.width / 2 - 28;

    if (instant) {
      var prev = circle.style.transition;
      circle.style.transition = 'none';
      circle.style.left = cx + 'px';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          circle.style.transition = prev || '';
        });
      });
    } else {
      circle.style.left = cx + 'px';
    }
  }

  /* ─── Set active tab ─── */
  function setActive(page, instant) {
    var matched = null;

    items.forEach(function (item) {
      var pg = item.getAttribute('data-page');
      var active = pg === page && page !== 'menu';
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-current', active ? 'page' : 'false');
      if (active) matched = item;
    });

    /* Menu: never permanently active */
    if (menuBtn) {
      menuBtn.classList.remove('is-active');
      menuBtn.setAttribute('aria-expanded', 'false');
    }

    if (matched) {
      circle.classList.remove('fb-nav__circle--hidden');
      positionCircle(matched, instant);
    } else {
      circle.classList.add('fb-nav__circle--hidden');
    }
  }

  /* ─── Click handlers ─── */
  items.forEach(function (item) {
    item.addEventListener('click', function (e) {
      var page = item.getAttribute('data-page');

      if (page === 'menu') {
        e.preventDefault();

        var shopifyBtn = findShopifyMenuBtn();
        if (shopifyBtn) {
          shopifyBtn.click();
          /* Brief visual feedback on menu button */
          menuBtn.setAttribute('aria-expanded', 'true');
        } else {
          /* Nothing found — try dispatching a custom event themes may listen to */
          document.dispatchEvent(new CustomEvent('header:open-menu-drawer'));
        }
        return;
      }

      /* For real nav links: update UI immediately before navigation */
      setActive(page, false);
    });
  });

  /* Reset menu aria-expanded when drawer closes */
  document.addEventListener('click', function (e) {
    if (menuBtn && menuBtn.getAttribute('aria-expanded') === 'true') {
      if (!nav.contains(e.target)) {
        menuBtn.setAttribute('aria-expanded', 'false');
      }
    }
  });

  ['menuDrawer:close', 'drawer:close', 'modal:close'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    });
  });

  /* ─── Cart badge live update ─── */
  function updateBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!badge) return;
        var n = data.item_count || 0;
        badge.textContent = n > 99 ? '99+' : String(n);
        if (n > 0) {
          badge.classList.remove('fb-nav__badge--hidden');
          badge.removeAttribute('aria-hidden');
        } else {
          badge.classList.add('fb-nav__badge--hidden');
          badge.setAttribute('aria-hidden', 'true');
        }
      })
      .catch(function () {});
  }

  /* Listen for Shopify cart events */
  ['cart:refresh', 'cart:updated', 'ajaxProduct:added'].forEach(function (e) {
    document.addEventListener(e, updateBadge);
  });

  /* Intercept fetch to cart endpoints */
  (function () {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var result = _fetch.apply(this, arguments);
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update)/.test(url)) {
        result.then(function () { setTimeout(updateBadge, 400); }).catch(function(){});
      }
      return result;
    };
  })();

  /* ─── Reposition on resize / orientation change ─── */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var active = nav.querySelector('.fb-nav__item.is-active');
      if (active) positionCircle(active, true);
    }, 160);
  });

  /* ─── Init ─── */
  function init() {
    setActive(detectPage(), true);
    updateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();